import brushes from '../util/brushes'

// paint app state
const state = {

  TOOLS: [
    'select',
    //'text',
    'pencil',
    'line',
    //'iso',
    //'curve',
    'spray',
    'rect',
    'roundrect',
    'circle',
    'oval',
    'blob',
    //'triangle',
    //'net',
    'move',
    'eraser',
    'brush',
    'bucket',
    'rectfill',
    'roundrectfill',
    'circlefill',
    'ovalfill',
    'blobfill',
    //'trianglefill'
  ],

  ENABLED_TOOLS: [
    'pencil', 'line', 'rect', 'circle', 'eraser', 'spray', 'brush',
    'rectfill', 'circlefill', 'oval', 'ovalfill', 'move', 'bucket',
    'blob', 'blobfill', 'triangle', 'trianglefill',
    'roundrect', 'roundrectfill', 'select'
  ],

  AVAILABLE_FONTS: [
      { val: 'monospaced', label: 'Courier'},
      { val: 'sans-serif', label: 'Helvetica'},
      { val: 'serif', label: 'Times'},
  ],

  AVAILABLE_BRUSHES: brushes.BRUSHES,

  AVAILABLE_STYLES: [
    { val: 'normal', label: 'Plain'},
    { val: 'bold', label: 'Bold'},
    { val: 'italic', label: 'Italic'},
    { val: 'underline', label: 'Underline'},
    { val: 'outline', label: 'Outline'},
    { val: 'strikeout', label: 'Strikeout'},
  ],

  AVAILABLE_FONT_SIZES: [
    [6,8,10,12,15,16,18,20,24,30],
    [32,36,37,40,42,45,48,50,56,60],
    [64,70,72,74,75,80,84]
  ],

  AVAILABLE_COLORS: [
    '#e3008c',
    '#a80000',
    '#e81123',
    '#d83b01',
    '#ff8c00',
    '#fff100',

    '#b4009e',
    '#5c005c',
    '#b4a0ff',
    '#5c2d91',
    '#32145a',
    '#00bcf2',

    '#bad80a',
    '#004b50',
    '#00b294',
    '#002050',
    '#00188f',
    '#0078d7',

    '#107c10',
    '#004b1c',
    '#ffffff',
    '#d2d2d2',
    '#737373',
    '#000000'
  ],

  title: '(untitled)',
  font: 'serif',
  fontSize: 16,
  style: 'normal',
  tool: 'brush',
  color: '#000000',
  lineWidth: 1,
  selectedBrush: brushes.BRUSHES[1],
  eraserBrush: brushes.BRUSHES[6],
  colorDisplay: true,
  alignment: 'left',
  transparent: false,
  grid: 0,
  paletteView: null,
  backgroundColor: '#ffffff',
  undoEnabled: false,
  currentView: 'boot-screen',
  readyForSave: false,

  isToolEnabled(t) {
    return this.ENABLED_TOOLS.indexOf(t) != -1;
  },

  setTool(t) {
    if(this.isToolEnabled(t)) {
      this.tool = t;
      window.paint.onToolChange(t);
    }
  },

  setColor(c) {
    this.color = c;
    this.closePalette();
  },

  setFont(f) {
    this.font = f;
  },

  setStyle(s) {
    this.style = s;
  },

  setAlignment(a) {
    this.alignment = a;
  },

  setFontSize(n) {
    this.fontSize = parseInt(n, 10);
  },

  setLineWidth(n) {
    this.lineWidth = Number(n);
    this.closePalette();
  },

  setBrush(n) {
    this.selectedBrush = brushes.BRUSHES[parseInt(n, 10)] || null;
    this.closePalette();
  },

  getSelectedBrushStamp() {
    return brushes.getStampImage(this.selectedBrush);
  },

  getEraserBrushStamp() {
    return brushes.getStampImage(this.eraserBrush);
  },

  setGrid(n) {
    this.grid = parseInt( n, 10);
  },

  toggleColorDisplay() {
    this.colorDisplay = !this.colorDisplay;
  },

  setTransparent( isTransparent ) {
    this.transparent = Boolean(isTransparent);
  },

  showPalette( name ) {
    setTimeout(()=>{
      this.paletteView = name;
    }, 125); // delayed for effect
  },

  closePalette() {
    setTimeout(()=>{
      this.paletteView = null;
    }, 100); // delayed for effect
  },

  toggleZoom() {
    $('body').toggleClass('zoom-zoom');
  }



};

export default state;



// WEBPACK FOOTER //
// ./src/data/state.js